import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { SelectivePreloadStrategy } from './selective-preload.strategy';
import { provideToastr } from 'ngx-toastr';
import { FlatpickrModule } from 'angularx-flatpickr';
import { provideHttpClient } from '@angular/common/http';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // P2: selectively preload only routes flagged `data: { preload: true }`, after an idle
    // delay — avoids eagerly fetching every (incl. heavy) chunk like PreloadAllModules did.
    provideRouter(routes, withPreloading(SelectivePreloadStrategy)),
    provideHttpClient(),
    // P3: lazy-load the animations engine instead of bundling it in the initial chunk
    provideAnimationsAsync(),
    provideToastr(),
    importProvidersFrom(FlatpickrModule.forRoot())
  ]
};
